<template>
  <div class="template-preview-card">
    <ItemPreviewCard type="router-link" :to="to" class="block">
      <div class="template-price">{{ price | formatPrice }}</div>
      <img v-lozad="imgUrl" :alt="name" class="mb-0" />
    </ItemPreviewCard>

    <router-link :to="to" class="template-name">
      {{ name }}
    </router-link>
  </div>
</template>

<script>
import ItemPreviewCard from "@/components/UI/ItemPreviewCard";

export default {
  name: "TemplatePreviewCard",
  components: { ItemPreviewCard },
  props: {
    imgUrl: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    to: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.template-name {
  @apply block text-center mt-3 font-sans text-xs text-grey-darker;

  &:hover {
    @apply no-underline text-brand;
  }
}

.template-price {
  @apply absolute text-xs bg-brand-light font-lato rounded shadow uppercase text-brand border border-brand-lighter;
  font-size: 12px;
  opacity: 0.9;
  padding: 3px 5px;
  right: -5px;
  transform: rotate(3deg);
  top: -5px;
}

>>> .item-preview-card {
  @apply relative;
}
</style>
